module.exports = __webpack_public_path__ + "img/number2.39fa4f5f.svg";